<template>
    <nav class="navbar navbar-expand-md navbar-light fixed-bottom bg-primary" role="navigation">
        <div class="container text-center">
            <button class="navbar-toggler navbar-light bg-light m-auto"
                    type="button"
                    data-toggle="collapse"
                    data-target="#navbarSupportedContent"
                    aria-controls="navbarSupportedContent"
                    aria-expanded="false"
                    aria-label="Toggle navigation"
            >
                <span class="navbar-toggler-icon"></span>
            </button>

            <div class="collapse navbar-collapse flex-column" id="navbarSupportedContent">
                <ul class="navbar-nav m-auto h5">
                    <li class="nav-item" v-for="item in items">
                        <a :href="item.url" :target="item.newTab ? '_blank' : ''" class="nav-link text-light">
                            <i v-if="item.icon" :class="'fa fa-' + item.icon" aria-hidden="true"></i>
                            {{ item.name }}
                        </a>
                    </li>
                    <li class="nav-item dropup">
                        <a aria-expanded="false" class="nav-link text-light" data-toggle="dropdown" href="#" role="button">
                            <i aria-hidden="true" class="fa fa-globe"></i>
                            {{ $t('Language') }}
                        </a>
                        <div class="dropdown-menu">
                            <a v-for="locale in locales"
                               :class="{active: locale.code === currentLocaleCode}"
                               :href="locale.code === currentLocaleCode ? false : `/locale/${locale.code}`"
                               class="dropdown-item"
                            >
                                {{ locale.name }}
                            </a>
                        </div>
                    </li>
                </ul>
                <ul class="navbar-nav m-auto small">
                    <li class="nav-item" v-for="item in subItems">
                        <a :href="item.url" :target="item.newTab ? '_blank' : ''" class="nav-link text-light pb-0">
                            {{ item.name }}
                        </a>
                    </li>
                </ul>
            </div>
        </div>
    </nav>
</template>

<script>
export default {
    name: 'Navbar',

    props: {
        items: Array,
        subItems: Array,
    },

    computed: {
        locales() {
            return this.$store.state.locale.locales;
        },

        currentLocaleCode() {
            return document.body.dataset.locale;
        },
    },

    mounted() {
        this.$store.dispatch("locale/loadLocales");
    },
}
</script>

<style>
#app {
    margin-bottom: 70px;
}
</style>
